import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import jwt from 'jwtservice/jwtService';
import { Navigate } from 'react-router';
import ApiConnectionError from 'views/error/ApiConnectionError';

// login option 3 routing
const LandingPage = Loadable(lazy(() => import('views/landing-page')));
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication/Login')));
const ForgotPasswordPage = Loadable(lazy(() => import('views/pages/authentication/authentication/ForgotPasswordPage')));
const ResetPasswordPage = Loadable(lazy(() => import('views/pages/authentication/authentication/ResetPasswordPage')));
const PrivacyPolicy = Loadable(lazy(() => import('views/landing-page/privacy/PrivacyPolicy')));
const Signup = Loadable(lazy(() => import('views/landing-page/signup/Signup')));
const CheckEmail = Loadable(lazy(() => import('views/landing-page/signup/CheckEmail')));
const VerifyEmail = Loadable(lazy(() => import('views/landing-page/signup/VerifyEmail')));
const Contact = Loadable(lazy(() => import('views/landing-page/contact/Contact')));
const IspBillingSoftware = Loadable(lazy(() => import('views/landing-page/seo/IspBillingSoftware')));
const IspManagementSystem = Loadable(lazy(() => import('views/landing-page/seo/IspManagementSystem')));
const MikrotikBilling = Loadable(lazy(() => import('views/landing-page/seo/MikrotikBilling')));
const InternetProviderSoftware = Loadable(lazy(() => import('views/landing-page/seo/InternetProviderSoftware')));
const FeaturesPage = Loadable(lazy(() => import('views/landing-page/seo/FeaturesPage')));
const PricingPage = Loadable(lazy(() => import('views/landing-page/seo/PricingPage')));
const NotFound = Loadable(lazy(() => import('views/landing-page/notfound/NotFound')));
const AccountDeletion = Loadable(lazy(() => import('views/landing-page/account-deletion/AccountDeletion')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const checkLogin = (element) => {
    return jwt.getIsLogin() !== true ? element : <Navigate to="/dashboard" replace={true} />;
};

const AuthenticationRoutes = {
    path: '/',
    element: checkLogin(<MinimalLayout />),
    children: [
        {
            path: '/',
            element: checkLogin(<LandingPage />)
        },
        {
            path: '/login',
            element: checkLogin(<AuthLogin />)
        },
        {
            path: '/api-error',
            element: checkLogin(<ApiConnectionError />)
        },
        {
            path: '/forgot-password',
            element: <ForgotPasswordPage />
        },
        {
            path: '/reset-password',
            element: <ResetPasswordPage />
        },
        {
            path: '/privacy-policy',
            element: <PrivacyPolicy />
        },
        {
            path: '/signup',
            element: checkLogin(<Signup />)
        },
        {
            path: '/check-email',
            element: <CheckEmail />
        },
        {
            path: '/verify-email',
            element: <VerifyEmail />
        }
    ]
};

export const ContactRoute = {
    path: '/contact',
    element: <Contact />
};

export const SeoRoutes = [
    { path: '/isp-billing-software',       element: <IspBillingSoftware /> },
    { path: '/isp-management-system',      element: <IspManagementSystem /> },
    { path: '/mikrotik-billing',           element: <MikrotikBilling /> },
    { path: '/internet-provider-software', element: <InternetProviderSoftware /> },
    { path: '/features',                   element: <FeaturesPage /> },
    { path: '/pricing',                    element: <PricingPage /> },
    { path: '/account-deletion',           element: <AccountDeletion /> }
];

export const NotFoundRoute = {
    path: '*',
    element: <NotFound />
};

export default AuthenticationRoutes;
